import React, { useEffect, useState } from "react";
import api from "../../api/api";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  Cell,
} from "recharts";

const getColorForScore = (score) => {
  if (score < 70) return "#e53935"; // Red
  if (score >= 70 && score <= 79) return "#616161"; // Deep gray
  if (score >= 80 && score <= 84) return "#64b5f6"; // Light blue
  if (score >= 85 && score <= 95) return "#1e88e5"; // Dark blue
  if (score > 95) return "#0d47a1"; // Very deep blue
  return "#ccc";
};

const StudentPerformanceChart = () => {
  const [grades, setGrades] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [periodOptions, setPeriodOptions] = useState([]);
  const [subject, setSubject] = useState("");
  const [period, setPeriod] = useState("");

  const fetchGrades = () => {
    let url = "/api/student-grade-performance/";
    const params = new URLSearchParams();
    if (subject) params.append("subject", subject);
    if (period) params.append("period", period);

    api
      .get(`${url}?${params.toString()}`)
      .then((res) => {
        setGrades(res.data);
        const subjects = [...new Set(res.data.map((g) => g.subject_name))];
        const periods = [...new Set(res.data.map((g) => g.period_name))];
        setSubjectOptions(subjects);
        setPeriodOptions(periods);
      })
      .catch((err) => console.error("Failed to load grades", err));
  };

  useEffect(() => {
    fetchGrades();
  }, [subject, period]);

  return (
    <Box sx={{ mt: 5 }}>
      <Typography variant="h6" gutterBottom>
        📊 Grade Performance Chart
      </Typography>

      <Box display="flex" gap={2} mb={2}>
        <FormControl sx={{ minWidth: 180 }}>
          <InputLabel>Filter by Subject</InputLabel>
          <Select
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            label="Filter by Subject"
          >
            <MenuItem value="">All</MenuItem>
            {subjectOptions.map((subj, i) => (
              <MenuItem key={i} value={subj}>
                {subj}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: 180 }}>
          <InputLabel>Filter by Period</InputLabel>
          <Select
            value={period}
            onChange={(e) => setPeriod(e.target.value)}
            label="Filter by Period"
          >
            <MenuItem value="">All</MenuItem>
            {periodOptions.map((per, i) => (
              <MenuItem key={i} value={per}>
                {per}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {grades.length > 0 ? (
        <ResponsiveContainer width="100%" height={350}>
          <BarChart data={grades}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="subject_name" />
            <YAxis domain={[0, 100]} />
            <Tooltip />
            <Bar dataKey="final_score">
              {grades.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={getColorForScore(entry.final_score)}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <Typography variant="body2">No grades available yet.</Typography>
      )}
    </Box>
  );
};

export default StudentPerformanceChart;


// import React, { useEffect, useState } from "react";
// import api from "../../api/api";
// import {
//   Box,
//   Typography,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
// } from "@mui/material";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   CartesianGrid,
//   ResponsiveContainer,
// } from "recharts";

// const StudentPerformanceChart = () => {
//   const [grades, setGrades] = useState([]);
//   const [subjectOptions, setSubjectOptions] = useState([]);
//   const [periodOptions, setPeriodOptions] = useState([]);
//   const [subject, setSubject] = useState("");
//   const [period, setPeriod] = useState("");

//   const fetchGrades = () => {
//     let url = "/api/student-grade-performance/";
//     const params = new URLSearchParams();
//     if (subject) params.append("subject", subject);
//     if (period) params.append("period", period);

//     api
//       .get(`${url}?${params.toString()}`)
//       .then((res) => {
//         setGrades(res.data);
//         const subjects = [...new Set(res.data.map((g) => g.subject_name))];
//         const periods = [...new Set(res.data.map((g) => g.period_name))];
//         setSubjectOptions(subjects);
//         setPeriodOptions(periods);
//       })
//       .catch((err) => console.error("Failed to load grades", err));
//   };

//   useEffect(() => {
//     fetchGrades();
//   }, [subject, period]);

//   return (
//     <Box sx={{ mt: 5 }}>
//       <Typography variant="h6" gutterBottom>
//         📊 Grade Performance Chart
//       </Typography>

//       <Box display="flex" gap={2} mb={2}>
//         <FormControl sx={{ minWidth: 180 }}>
//           <InputLabel>Filter by Subject</InputLabel>
//           <Select
//             value={subject}
//             onChange={(e) => setSubject(e.target.value)}
//             label="Filter by Subject"
//           >
//             <MenuItem value="">All</MenuItem>
//             {subjectOptions.map((subj, i) => (
//               <MenuItem key={i} value={subj}>
//                 {subj}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>

//         <FormControl sx={{ minWidth: 180 }}>
//           <InputLabel>Filter by Period</InputLabel>
//           <Select
//             value={period}
//             onChange={(e) => setPeriod(e.target.value)}
//             label="Filter by Period"
//           >
//             <MenuItem value="">All</MenuItem>
//             {periodOptions.map((per, i) => (
//               <MenuItem key={i} value={per}>
//                 {per}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Box>

//       {grades.length > 0 ? (
//         <ResponsiveContainer width="100%" height={350}>
//           <BarChart data={grades}>
//             <CartesianGrid strokeDasharray="3 3" />
//             <XAxis dataKey="subject_name" />
//             <YAxis domain={[0, 100]} />
//             <Tooltip />
//             <Bar dataKey="final_score" fill="#1976d2" />
//           </BarChart>
//         </ResponsiveContainer>
//       ) : (
//         <Typography variant="body2">No grades available yet.</Typography>
//       )}
//     </Box>
//   );
// };

// export default StudentPerformanceChart;
